import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { List, Map } from 'immutable'
import { Lightbox } from 'ngx-lightbox'

@Component({
  selector: 'property-photo-gallery',
  templateUrl: './property-photo-gallery.component.html',
  styleUrls: ['./property-photo-gallery.component.css'],
})
export class PropertyPhotoGalleryComponent implements OnInit, OnChanges {
  @Input() public images: Map<string, any>
  @Input() public imageTypes: List<Map<string, any>>
  @Input() public imageBaseUrl: string
  @Input() public shouldReload: boolean
  @Input() public editable: boolean
  @Input() public isReadonly: boolean
  @Output() public upload: EventEmitter<any> = new EventEmitter()
  @Output() public delete: EventEmitter<any> = new EventEmitter()
  @ViewChild('file', { read: ElementRef, static: false }) fileElement: any
  public _randomKey: any

  constructor(private _lightbox: Lightbox) {}

  ngOnInit() {
    this._randomKey = this.randomKey()
  }

  ngOnChanges() {
    this._randomKey = this.randomKey()
  }

  public randomKey() {
    return new Date().getTime()
  }

  public triggerFileBrowse(event: Event) {
    this.fileElement.nativeElement.click()
  }

  public hasImage(key: string): boolean {
    return this.images && (this.images.getIn([key, 'imagePath']) as boolean)
  }

  public getImageUrl(key: string): string {
    const filename = this.images && this.images.getIn([key, 'imagePath'])
    const url = `${this.imageBaseUrl}/${filename}`
    const placeholder = '../../../assets/placeholder-800x600.jpg'
    return filename ? `${url}?v=${this._randomKey}` : placeholder
  }

  public get gallery(): any[] {
    return this.imageTypes
      .map((imageType) => ({
        src: this.getImageUrl(imageType.get('name')),
        caption: imageType.get('title'),
      }))
      .toJS()
      .filter((img) => img.src.includes('http'))
  }

  public open(index: number, enable?: boolean) {
    if (enable) {
      this._lightbox.open(this.gallery, index, {
        centerVertically: true,
      })
    }
  }
}
